import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { CardGrafico } from './CardGrafico';
import { useChartTheme } from './ChartTheme';
import { fmtBRL } from './formatadores';
import type { DashboardFinanceiro } from '../../types';

export function GraficoSocios({ dados }: { dados: DashboardFinanceiro['por_socio'] }) {
  const t = useChartTheme();
  const vazio = !dados.length || dados.every((d) => d.total <= 0);
  return (
    <CardGrafico titulo="Divisão por sócio" vazio={vazio} msgVazio="Cadastre sócios e receitas para ver a divisão">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie data={dados} dataKey="total" nameKey="socio_nome" innerRadius="55%" outerRadius="80%" paddingAngle={2} stroke="none">
            {dados.map((_, i) => <Cell key={i} fill={t.paleta[i % t.paleta.length]} />)}
          </Pie>
          <Tooltip
            formatter={(v: number, n) => [fmtBRL(v), n as string]}
            contentStyle={{ background: t.tooltipBg, border: `1px solid ${t.grid}`, borderRadius: 8, fontSize: 12, color: t.texto }}
          />
          <Legend wrapperStyle={{ fontSize: 12, color: t.texto }} />
        </PieChart>
      </ResponsiveContainer>
    </CardGrafico>
  );
}
